module.exports = __webpack_public_path__ + "img/pleasure-icon-4.3949ef5b.svg";